import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, BookOpen, Download, Calendar, FileText } from 'lucide-react';

export default function Colles20232024() {
  const { t } = useTranslation();

  // List of enoncés files for 2023-2024
  const enoncesFiles = [
    { name: "Colles LLG 1 (23-24)", file: "Colles LLG 1 (23-24).pdf" },
    { name: "Colles LLG 2 (23-24)", file: "Colles LLG 2 (23-24).pdf" },
    { name: "Colles LLG 3 (23-24)", file: "Colles LLG 3 (23-24).pdf" },
    { name: "Colles LLG 4 (23-24)", file: "Colles LLG 4 (23-24).pdf" },
    { name: "Colles LLG 5 (23-24)", file: "Colles LLG 5 (23-24).pdf" },
    { name: "Colles LLG 6 (23-24)", file: "Colles LLG 6 (23-24).pdf" },
    { name: "Colles LLG 8 (23-24)", file: "Colles LLG 8 (23-24).pdf" },
    { name: "Colles LLG 9 (23-24)", file: "Colles LLG 9 (23-24).pdf" },
    { name: "Colles LLG 10 (23-24)", file: "Colles LLG 10 (23-24).pdf" },
    { name: "Colles LLG 11 (23-24)", file: "Colles LLG 11 (23-24).pdf" },
    { name: "Colles LLG 12 (23-24)", file: "Colles LLG 12 (23-24).pdf" },
    { name: "Colles LLG 13 (23-24)", file: "Colles LLG 13 (23-24).pdf" },
    { name: "Colles LLG 14 (23-24)", file: "Colles LLG 14 (23-24).pdf" },
    { name: "Colles LLG 15 (23-24)", file: "Colles LLG 15 (23-24).pdf" },
    { name: "Colles LLG 16 (23-24)", file: "Colles LLG 16 (23-24).pdf" },
    { name: "Colles LLG 17 (23-24)", file: "Colles LLG 17 (23-24).pdf" },
    { name: "Colles LLG 18 (23-24)", file: "Colles LLG 18 (23-24).pdf" },
    { name: "Colles LLG 19 (23-24)", file: "Colles LLG 19 (23-24).pdf" },
  ];

  // List of corrigés files for 2023-2024
  const corrigesFiles = [
    { name: "Corrigés Colles LLG 1 (23-24)", file: "Corrigés Colle LLG 1 (23-24).pdf" },
    { name: "Corrigés Colles LLG 2 (23-24)", file: "Corrigés Colle LLG 2 (23-24).pdf" },
    { name: "Corrigés Colles LLG 3 (23-24)", file: "Corrigés Colle LLG 3 (23-24).pdf" },
    { name: "Corrigés Colles LLG 4 (23-24)", file: "Corrigés Colle LLG 4 (23-24).pdf" },
    { name: "Corrigés Colles LLG 5 (23-24)", file: "Corrigés Colle LLG 5 (23-24).pdf" },
    { name: "Corrigés Colles LLG 6-7 (23-24)", file: "Corrigés Colle LLG 6_7 (23-24).pdf" },
    { name: "Corrigés Colles LLG 8 (23-24)", file: "Corrigés Colle LLG 8 (23-24).pdf" },
    { name: "Corrigés Colles LLG 9-10 (23-24)", file: "Corrigés Colle LLG 9_10 (23-24).pdf" },
    { name: "Corrigés Colles LLG 11 (23-24)", file: "Corrigés Colle LLG 11 (23-24).pdf" },
    { name: "Corrigés Colles LLG 12 (23-24)", file: "Corrigés Colle LLG 12 (23-24).pdf" },
    { name: "Corrigés Colles LLG 13 (23-24)", file: "Corrigés Colle LLG 13 (23-24).pdf" },
    { name: "Corrigés Colles LLG 14 (23-24)", file: "Corrigés Colle LLG 14 (23-24).pdf" },
    { name: "Corrigés Colles LLG 15 (23-24)", file: "Corrigés Colle LLG 15 (23-24).pdf" },
    { name: "Corrigés Colles LLG 16 (23-24)", file: "Corrigés Colle LLG 16 (23-24).pdf" },
    { name: "Corrigés Colles LLG 17 (23-24)", file: "Corrigés Colles LLG 17 (23-24).pdf" },
    { name: "Corrigés Colles LLG 18 (23-24)", file: "Corrigés Colles LLG 18 (23-24).pdf" },
    { name: "Corrigés Colles LLG 19 (23-24)", file: "Corrigés Colles LLG 19 (23-24).pdf" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-6xl mx-auto"
    >
      {/* Header */}
      <div className="mb-8">
        <Link 
          to="/teaching"
          className="inline-flex items-center text-[#735d78] hover:text-[#614c66] mb-4 transition-colors duration-200"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          {t('teaching.colles.backToColles')}
        </Link>
        
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="font-display text-5xl md:text-6xl font-semibold text-stone-800 mb-4">
            Colles 2023-2024
          </h1>
          <p className="text-xl text-stone-600">
            {t('teaching.colles.academicYear')} 2023-2024
          </p>
        </motion.div>
      </div>

      {/* PC*1 LLG Section */}
      <motion.div 
        className="bg-[rgba(255,251,246,0.82)] backdrop-blur-sm rounded-[1.75rem] p-8 mb-8 shadow-[0_20px_60px_rgba(31,41,55,0.08)] border border-stone-200/80"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <div className="flex items-center mb-6">
          <BookOpen className="w-8 h-8 text-[#735d78] mr-3" />
          <h2 className="font-display text-4xl font-semibold text-stone-800">PC*1 LLG (23-24)</h2>
        </div>
        
        <p className="text-stone-600 mb-8">
          {t('teaching.colles.llg2023')}
        </p>

        {/* Énoncés Section */}
        <div className="mb-8">
          <h3 className="font-display text-3xl font-semibold text-stone-800 mb-4 flex items-center">
            <FileText className="w-6 h-6 mr-2 text-[#735d78]" />
            {t('common.enonce')}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {enoncesFiles.map((file, index) => (
              <motion.a
                key={file.name}
                href={`/files/colles23-24/enonces/${file.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[linear-gradient(135deg,rgba(250,247,250,0.95),rgba(240,232,240,0.92))] rounded-lg p-4 hover:shadow-lg transition-all duration-200 border border-[#d7d0d9] hover:border-[#c8bcc9]"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 + index * 0.05 }}
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-medium text-stone-800">{file.name}</p>
                    <p className="text-sm text-stone-500">{t('common.enonce')}</p>
                  </div>
                  <Download className="w-5 h-5 text-[#735d78]" />
                </div>
              </motion.a>
            ))}
          </div>
        </div>

        {/* Corrigés Section */}
        <div>
          <h3 className="font-display text-3xl font-semibold text-stone-800 mb-4 flex items-center">
            <FileText className="w-6 h-6 mr-2 text-[#8a6f88]" />
            {t('common.corrige')}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {corrigesFiles.map((file, index) => (
              <motion.a
                key={file.name}
                href={`/files/colles23-24/corriges/${file.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[linear-gradient(135deg,rgba(250,247,250,0.95),rgba(240,232,240,0.92))] rounded-lg p-4 hover:shadow-lg transition-all duration-200 border border-[#d7d0d9] hover:border-[#c8bcc9]"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 + index * 0.05 }}
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-medium text-stone-800">{file.name}</p>
                    <p className="text-sm text-stone-500">{t('common.corrige')}</p>
                  </div>
                  <Download className="w-5 h-5 text-[#8a6f88]" />
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </motion.div>

      {/* Note Section */}
      <motion.div 
        className="bg-[linear-gradient(135deg,rgba(250,248,244,0.95),rgba(243,239,231,0.92))] rounded-2xl p-6 border border-stone-200/80"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.0 }}
      >
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <Calendar className="w-6 h-6 text-[#8a7767] mt-1" />
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-semibold text-stone-800 mb-2">{t('teaching.colles.note')}</h3>
            <p className="text-stone-700">
              {t('teaching.colles.noteDesc')}
            </p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}; 
